import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrProductData } from './hook';
import { PqrProductDataProps } from './props';

export const PqrProductData = (props: PqrProductDataProps) => {
    const { formik } = usePqrProductData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Datos producto
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Póliza"
                    name="policy"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.policy}
                    errors={formik.errors.policy}
                    value={formik.values.policy}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Valor de la prima"
                    name="bonusValue"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.bonusValue}
                    errors={formik.errors.bonusValue}
                    value={formik.values.bonusValue}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Placa"
                    name="plate"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.plate}
                    errors={formik.errors.plate}
                    value={formik.values.plate}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
